export const TOKEN_KEY = "access_token";
export const USER_KEY = "user";
export const ACTING_TEACHER_KEY = "acting_teacher_id";
export const ACCOUNTS_CACHE_KEY = "accessible_accounts_v2";
